// extracted by mini-css-extract-plugin
export default {"shopPageWrapper":"styles_shopPageWrapper__vhzPw"};